module.exports = __webpack_public_path__ + "static/media/vision-login-page.3e211881.gif";